export default {
  sale: "Atualizações de Vendas",
  update_customer: "Atualizações de Clientes",
  create_customer: "Criação de Clientes"
};



// WEBPACK FOOTER //
// ./src/core/enum/webhook-actions.enum.js